'use-strict';

export default function initializeAnalytics(instrumentationKey, site, env, appHistory) {
	if (!instrumentationKey) return false;

	return true;
}